document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  if (toggle && drawer) toggle.addEventListener('click', () => {
    const open = drawer.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });
  document.querySelectorAll('[data-team-search]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const input = form.querySelector('input');
      if (!input || !input.value.trim()) event.preventDefault();
    });
  });
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const price = document.querySelector('[data-product-price]');
      if (price) price.textContent = select.selectedOptions[0].dataset.price || price.textContent;
    });
  });
});
